<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <NotificationToaster />
</template>

<script setup lang="ts">
import { useCurrentUser } from 'vuefire'
import { NotificationToaster } from '~/components/notifications'

const router = useRouter()
const route = useRoute()
const user = useCurrentUser()

// Use the centralized core subscriptions manager
const { setupCoreSubscriptions, getSubscriptionDiagnostics } = useCoreSubscriptions()

// Track whether we're actually forcing a refresh
const isForceRefresh = ref(false)

// Function to expose for DevTools to force subscription refresh
const refreshCoreSubscriptions = async () => {
  isForceRefresh.value = true
  console.warn('[App] Manual refresh of core subscriptions requested')
  try {
    return await setupCoreSubscriptions()
  }
  finally {
    isForceRefresh.value = false
  }
}

// Handle navigation after login/logout
watch(user, (newUser, prevUser) => {
  if (prevUser && !newUser) {
    // User logged out
    router.push('/login')
  }
  else if (newUser && typeof route.query.redirect === 'string') {
    // User logged in with redirect query
    router.push(route.query.redirect)
  }
})

// Expose the refresh function for DevTools
defineExpose({
  setupCoreSubscriptions: refreshCoreSubscriptions,
  getSubscriptionDiagnostics,
})
</script>
